module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/how-works-desktop--pt.53da5179.svg";